import React from 'react';
import PropTypes from 'prop-types';
import { propTypes } from '../../../../util/types';
import { FormattedMessage } from '../../../../util/reactIntl';
import { ListingCard } from '../../../../components';
import classNames from 'classnames';

import css from './ProfileNavListingsPanel.module.css';

const ProfileNavListingsPanel = props => {
  const {
    rootClassName,
    className,
    listings,
    searchListingsInProgress,
    searchListingsError,
    searchFiltersComponent,
    sortByComponent,
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  const renderContent = (messageId, messageClass) => (
    <div className={classes}>
      <div className={css.container}>
        <div className={css.mobileSearchFilters}>{searchFiltersComponent.mobile}</div>
        <div className={css.desktopSortBy}>{sortByComponent}</div>
        <div className={css.listingsContainer}>
          <aside className={css.filtersColumn}>{searchFiltersComponent.desktop}</aside>
          <div className={css.listingsColumn}>
            <p className={messageClass}>
              <FormattedMessage id={messageId} />
            </p>
          </div>
        </div>
      </div>
    </div>
  );

  if (searchListingsInProgress) {
    return renderContent('ProfileNavListingsPanel.loadingListings', css.loading);
  }

  if (searchListingsError) {
    return renderContent('ProfileNavListingsPanel.loadingListingsFailed', css.error);
  }

  if (!searchListingsInProgress && listings.length === 0) {
    return renderContent('ProfileNavListingsPanel.noListings', css.noResults);
  }

  return (
    <div className={classes}>
      <div className={css.container}>
        <div className={css.mobileSearchFilters}>{searchFiltersComponent.mobile}</div>
        <div className={css.desktopSortBy}>
          {sortByComponent}
        </div>
        <div className={css.listingsContainer}>
          <aside className={css.filtersColumn}>{searchFiltersComponent.desktop}</aside>
          <div className={css.listingsColumn}>
            <div className={css.listings}>
              {listings.map(l => (
                <ListingCard key={l.id.uuid} listing={l} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ProfileNavListingsPanel.defaultProps = {
  rootClassName: null,
  className: null,
  listings: [],
  searchListingsInProgress: false,
  searchListingsError: null,
  searchFiltersComponent: null,
  sortByComponent: null,
};

const { arrayOf, shape, string, bool, node } = PropTypes;

ProfileNavListingsPanel.propTypes = {
  rootClassName: string,
  className: string,
  listings: arrayOf(propTypes.listing),
  searchListingsInProgress: bool,
  searchListingsError: propTypes.error,
  searchFiltersComponent: shape({
    desktop: node.isRequired,
    mobile: node.isRequired,
  }),
  sortByComponent: node.isRequired,
};

export default ProfileNavListingsPanel;
